module.exports = __webpack_public_path__ + "img/02.369a4eb2.png";